import { render, staticRenderFns } from "./Ordonnance.vue?vue&type=template&id=7401cebb&"
import script from "./Ordonnance.vue?vue&type=script&lang=js&"
export * from "./Ordonnance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports